<template>
  <main class="pwa-install-prompt" dir="rtl" aria-labelledby="pwa-install-title">
    <div class="pwa-install-prompt__card">
      <img class="pwa-install-prompt__logo" src="/logo/android-icon-192x192.png" alt="نشان ایرانی بانک" />
      <span class="pwa-install-prompt__eyebrow">دسترسی به امکانات حساب با نسخه نصب‌شده</span>
      <h1 id="pwa-install-title">وب‌اپ را نصب کنید</h1>
      <p>برای مدیریت حساب‌ها، سپرده‌ها و استفاده از خدمات بانکی در موبایل و تبلت، ایرانی بانک را نصب و از آیکن آن اجرا کنید.</p>
      <p v-if="access.installCompleted" class="pwa-install-prompt__status" role="status">نصب پذیرفته شد. برنامه را از آیکن آن باز کنید؛ امکانات حساب در این تب مرورگر باز نمی‌شوند.</p>
      <p v-else class="pwa-install-prompt__hint">اگر قبلاً نصب کرده‌اید، برنامه را از آیکن ایرانی بانک در صفحه اصلی باز کنید. ممکن است ورود دوباره به حساب لازم باشد.</p>
      <p v-if="access.error" class="pwa-install-prompt__error" role="alert">{{ access.error }}</p>
      <p v-if="access.message" class="pwa-install-prompt__status" role="status">{{ access.message }}</p>

      <button v-if="!access.installCompleted" type="button" class="pwa-install-prompt__primary" :disabled="access.installing" @click="install">
        {{ access.installing ? 'در حال آماده‌سازی...' : (access.deferredPrompt ? 'نصب وب‌اپ' : 'راهنمای نصب دستی') }}
      </button>
      <section v-if="access.isIOS || !access.deferredPrompt || access.manualRequested" class="pwa-install-prompt__steps" aria-labelledby="pwa-manual-title">
        <h2 id="pwa-manual-title">{{ access.isIOS ? 'نصب روی آیفون و آیپد' : 'نصب روی اندروید' }}</h2>
        <ol v-if="access.isIOS">
          <li>آدرس app.irani-bank.com را ترجیحاً در Safari باز کنید.</li>
          <li>از منوی Share گزینه Add to Home Screen را انتخاب کنید.</li>
          <li>اگر Open as Web App نمایش داده شد، آن را روشن نگه دارید؛ سپس Add را بزنید و برنامه را از آیکن آن اجرا کنید.</li>
        </ol>
        <ol v-else>
          <li>آدرس app.irani-bank.com را در Chrome یا مرورگر دارای نصب وب‌اپ باز کنید.</li>
          <li>از منوی مرورگر Install app یا Add to Home screen را انتخاب و نصب را تأیید کنید.</li>
          <li>ایرانی بانک را از آیکن آن اجرا کنید. میانبری که دوباره در تب مرورگر باز شود، دسترسی به امکانات حساب ندارد.</li>
        </ol>
        <p>اگر گزینه نصب در مرورگر داخلی تلگرام یا اینستاگرام دیده نمی‌شود، لینک را در مرورگر اصلی دستگاه باز کنید.</p>
        <p>نبودن دکمه نصب لزوماً به معنی ناسازگاری نیست؛ گزینه نصب در منوی مرورگر را هم بررسی کنید.</p>
      </section>
      <a class="pwa-install-prompt__guide" href="https://irani-bank.com/download-guide.html" target="_blank" rel="noopener noreferrer">راهنمای تصویری نصب</a>
      <button type="button" class="pwa-install-prompt__limited" @click="continueLimited">ادامه در صفحات عمومی</button>
      <p class="pwa-install-prompt__hint">در حالت محدود، فقط ورود، ثبت‌نام، بازیابی، درباره و تماس در دسترس است؛ امکانات حساب باز نمی‌شوند.</p>
    </div>
  </main>
</template>

<script>
import { pwaInstallState, enableLimitedAccess, requestPwaInstallation } from '../pwaInstall'

export default {
  name: 'PwaInstallPrompt',
  data () {
    return { access: pwaInstallState }
  },
  methods: {
    install: requestPwaInstallation,
    continueLimited () {
      enableLimitedAccess()
      this.$router.replace({ name: 'Welcome' })
    }
  }
}
</script>

<style scoped>
.pwa-install-prompt { position: fixed; z-index: 9000; inset: 0; overflow-y: auto; padding: max(24px, env(safe-area-inset-top)) 20px max(24px, env(safe-area-inset-bottom)); background: #e7effa; font-family: 'IRANSansXFaNum-Light', sans-serif; }
.pwa-install-prompt__card { box-sizing: border-box; width: min(100%, 460px); margin: 0 auto; padding: 32px 24px 24px; border: 1px solid rgba(255, 255, 255, .72); border-radius: 28px; background: linear-gradient(145deg, #fff, #eff6ff); box-shadow: 0 24px 70px rgba(0, 0, 0, .18); text-align: center; }
.pwa-install-prompt__logo { display: block; width: 82px; height: 82px; margin: 0 auto 14px; object-fit: contain; }
.pwa-install-prompt__eyebrow { color: #3d78c5; font-size: 13px; font-weight: 700; }
.pwa-install-prompt h1 { margin: 8px 0 10px; color: #1f2f4d; font-size: 25px; font-weight: 800; }
.pwa-install-prompt p { margin: 0 auto 22px; color: #5d6b83; font-size: 14px; line-height: 2; }
.pwa-install-prompt__primary, .pwa-install-prompt__limited { width: 100%; border: 0; border-radius: 12px; min-height: 50px; font-family: inherit; font-size: 15px; font-weight: 700; cursor: pointer; }
.pwa-install-prompt__primary { color: #fff; background: #3679ce; box-shadow: 0 10px 22px rgba(54, 121, 206, .26); }
.pwa-install-prompt__primary:disabled { cursor: wait; opacity: .68; }
.pwa-install-prompt__guide { display: inline-block; margin: 17px 0 8px; color: #3268bd; font-size: 14px; font-weight: 700; text-decoration: none; }
.pwa-install-prompt__limited { color: #3268bd; background: #e2edfc; }
.pwa-install-prompt__steps { margin-top: 20px; text-align: right; }
.pwa-install-prompt__steps h2 { color: #1f2f4d; font-size: 18px; }
.pwa-install-prompt__steps ol { padding-inline-start: 22px; color: #465a77; font-size: 14px; line-height: 2; }
.pwa-install-prompt__steps li { margin-bottom: 8px; }
.pwa-install-prompt p.pwa-install-prompt__hint { margin-top: 12px; font-size: 12px; }
.pwa-install-prompt p.pwa-install-prompt__status { padding: 12px; border-radius: 10px; color: #245b3b; background: #e5f5ec; }
.pwa-install-prompt p.pwa-install-prompt__error { color: #a32222; }
</style>
